export interface FormDataProps {
    type: string
    visitors: number
    spend: number
    result: number
    resultWBlytz: number
    resultDifference: number
    firstName: string
    lastName: string
    email: string
    telnumber: string
    projectName: string
}

export interface BusinessTypesProps {
    value: string
    label: string
    step2Config: {
        minVisitors: number
        midVisitors: number
        maxVisitors: number
        minSpend: number
        maxSpend: number
    }
    type: "event" | "installation" | "other"
}

export const BUSINESS_TYPES: BusinessTypesProps[] = [
    {
        value: "Evento / Festival",
        label: "Organizzatore di eventi o festival",
        step2Config: {
            minVisitors: 200,
            midVisitors: 5_000,
            maxVisitors: 50_000,
            minSpend: 10,
            maxSpend: 60,
        },
        type: "event",
    },
    {
        value: "Discoteca / Club",
        label: "Discoteca o club",
        step2Config: {
            minVisitors: 2_500,
            midVisitors: 50_000,
            maxVisitors: 500_000,
            minSpend: 10,
            maxSpend: 60,
        },
        type: "installation",
    },
    {
        value: "Fiera, conferenza o sagra",
        label: "Organizzatore di fiere, congressi o sagre",
        step2Config: {
            minVisitors: 200,
            midVisitors: 5_000,
            maxVisitors: 50_000,
            minSpend: 10,
            maxSpend: 60,
        },
        type: "event",
    },
    {
        value: "Stabilimento balneare",
        label: "Stabilimento balneare",
        step2Config: {
            minVisitors: 2_500,
            midVisitors: 50_000,
            maxVisitors: 500_000,
            minSpend: 10,
            maxSpend: 60,
        },
        type: "installation",
    },
    {
        value: "Parco divertimento o tematico / Acquapark",
        label: "Parco divertimento o tematico / Acquapark",
        step2Config: {
            minVisitors: 2_500,
            midVisitors: 50_000,
            maxVisitors: 500_000,
            minSpend: 10,
            maxSpend: 60,
        },
        type: "installation",
    },
    {
        value: "Villaggio turistico / Campeggio",
        label: "Villaggio turistico / Campeggio",
        step2Config: {
            minVisitors: 2_500,
            midVisitors: 50_000,
            maxVisitors: 500_000,
            minSpend: 10,
            maxSpend: 60,
        },
        type: "installation",
    },
    {
        value: "Altro",
        label: "...Altro",
        step2Config: {
            minVisitors: 2_500,
            midVisitors: 50_000,
            maxVisitors: 500_000,
            minSpend: 10,
            maxSpend: 60,
        },
        type: "installation",
    },
]
